import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { PauseCircle, Check } from 'lucide-react';
import { VideoFeatures } from '@/store/videoFeatures/types';
import { HeroCard } from '@/components/ui/HeroCard';

interface SmartPauseConfigProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const SmartPauseConfig: React.FC<SmartPauseConfigProps> = ({ features, setFeature }) => {
  useLanguage();
  const enabled = features.smartPause ?? false;

  const handleToggle = (value: boolean) => {
    setFeature('smartPause', value);
  };

  return (
    <div className="space-y-3 p-4">
      <HeroCard
        icon={<PauseCircle className="w-full h-full" strokeWidth={2} />}
        title={translateInterfaceText("Pausa Inteligente")}
        description={translateInterfaceText("Pausa o vídeo automaticamente quando o espectador sai da aba do navegador.")}
        isActive={enabled}
        onToggle={handleToggle}
      />

      <p className="text-[11px] text-[#9CA3AF] px-1">
        {translateInterfaceText("Funciona quando o visitante troca de aba ou minimiza o navegador.")}</p>

      <div className="rounded-[16px] border border-[#E4E7EC] bg-white p-7 flex flex-col items-center text-center">
        <div
          className={`w-11 h-11 rounded-[12px] flex items-center justify-center mb-4 ${
            enabled ? 'bg-[#EEF4FF] text-[#1D4FFF]' : 'bg-[#F3F4F6] text-[#9CA3AF]'
          }`}
        >
          <PauseCircle className="w-[22px] h-[22px]" strokeWidth={2} />
        </div>

        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-[15px] font-semibold text-[#1A1A1A] leading-tight">
            {enabled ? translateInterfaceText("Pausa inteligente ativada") : translateInterfaceText("Pausa inteligente desativada")}
          </h3>
        </div>

        <p className="text-[13px] text-[#6B7280] leading-relaxed max-w-[280px]">
          {enabled
            ? translateInterfaceText("O vídeo pausa automaticamente quando o visitante sai da aba, retomando ao voltar.")
            : translateInterfaceText("Ative o recurso acima para pausar o vídeo quando o visitante sair da aba do navegador.")}
        </p>
      </div>
    </div>
  );
};
